module.exports = __webpack_public_path__ + "img/icon-document.9e84a24d.svg";